// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Qyzz","notes":"Notes_notes__395-r"};